import React, { ReactElement } from 'react';
import {
  Col, Heading,
  Input, Label, Row,
} from 'idsk-react-components';
import { SearchPouzivatelList, SearchPouzivatelskaSkupina } from '../../SearchLdapData';
import './pripomienkovatelFormSection.scss';
import { SafeParameterSetter } from '../../../types/SafeParameterSetter';
import SaveAdminPripomienka from '../../../model/pripomienka/SaveAdminPripomienka';

interface Props {
  pripomienka: SaveAdminPripomienka;
  onUpdateField: SafeParameterSetter<SaveAdminPripomienka>;
}

const PripomienkovatelFormSection = ({
  pripomienka,
  onUpdateField,
}: Props): ReactElement => (
  <section className="add-pripomienka-admin__pripomienkovatel-form-section">
    <Row className="row-heading">
      <Col width="one-quarter">
        <Heading size="m">PRIPOMIENKOVATEĽ</Heading>
      </Col>
    </Row>
    <SearchPouzivatelskaSkupina
      skupina={pripomienka.pripomienkujuciSubjekt}
      setSkupina={(data) => onUpdateField('pripomienkujuciSubjekt', data)}
      label="Pripomienkujúci subjekt"
    />
    <SearchPouzivatelList
      pouzivatel={pripomienka.pripomienkovatel}
      setPouzivatel={(data) => onUpdateField('pripomienkovatel', data)}
      label="Pripomienkovateľ"
    />
    <Row>
      <Col width="one-half" className="pripomienkovatel-email-disabled">
        <Label
          htmlFor="pripomienkovatel-email"
        >
          Email pripomienkovateľa
        </Label>
        <Input
          id="pripomienkovatel-email"
          type="text"
          value={pripomienka.pripomienkovatel ? pripomienka.pripomienkovatel.shortName : ''}
          disabled
        />
      </Col>
    </Row>
  </section>
);

export default PripomienkovatelFormSection;
